/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */

export type LanguagePersistenceSource = 'canonical-settings' | 'configured-legacy';

export interface LanguagePersistenceResult<T> {
  source: LanguagePersistenceSource;
  response: T;
}

interface PersistUserLanguageOptions<T> {
  persistCanonical: () => Promise<T>;
  persistLegacy?: () => Promise<T>;
}

/**
 * Kullanıcı dilinin tek kanonik kalıcılık yolunu önce dener.
 *
 * QubePro uyduları `/api/settings/user` çağrısını kendi BFF'leri üzerinden Core'a
 * iletir. Eski `/api/auth/me/language` sözleşmesi yalnız host açıkça bir endpoint
 * verdiğinde ve kanonik istek başarısız olduğunda geri dönüş olarak kullanılabilir.
 */
export async function persistUserLanguage<T>({
  persistCanonical,
  persistLegacy,
}: PersistUserLanguageOptions<T>): Promise<LanguagePersistenceResult<T>> {
  try {
    return {
      source: 'canonical-settings',
      response: await persistCanonical(),
    };
  } catch (canonicalError) {
    if (!persistLegacy) throw canonicalError;
    return {
      source: 'configured-legacy',
      response: await persistLegacy(),
    };
  }
}
